module.exports = __webpack_public_path__ + "static/src/content/project/book.460862b.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/project/book.png
// module id = qcnL
// module chunks = 1